<template>
    <div>test</div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
        };
    },

    mounted() {},

    methods: {},
};
</script>



// WEBPACK FOOTER //
// DetailBundle.vue?481f0046